var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.productInfo)?_c('ProductListItemComponent',{staticClass:"mb-8",attrs:{"item":_vm.productInfo,"is-dynamic-parts":"","variant-codes":_vm.targetVariantCodes}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }